export default "__VITE_ASSET__BbC8_DVN__"